import api from '..';
import useResourceList from './useResourceList';
import useQuery from './useQuery';
import { transformEventChampionships } from '@api/utils';

export const useDisciplinesList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'disciplines', api: api.disciplines }, queryVariables, queryConfig);

  return {
    disciplines: queryResult.resolvedData,
    latestDisciplines: queryResult.latestData,
    ...queryResult,
  };
};

export const useEventDisciplines = (eventId, queryConfig = {}) => {
  const queryResult = useQuery(['event', { eventId }], api.disciplines.getEventDisciplines, {
    ...queryConfig,
    enabled: eventId,
  });

  return {
    eventDisciplines: queryResult.data,
    ...queryResult,
  };
};

export const useChampionshipDisciplines = (eventId, queryConfig = {}) => {
  const queryResult = useQuery(['event', { eventId }], api.disciplines.getChampionshipDisciplines, {
    ...queryConfig,
    enabled: eventId,
  });

  return {
    eventDisciplines: queryResult.data,
    ...queryResult,
  };
};

export const useEventsDisciplinesByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['disciplines', { ids }], api.disciplines.getEventsDisciplinesByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  const result = [...new Map(queryResult?.data?.flat().map((item) => [item.id, item])).values()];

  return {
    eventDisciplines: result || [],
    ...queryResult,
  };
};

export const useChampionshipsDisciplinesByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['disciplines', { ids }], api.disciplines.getChampionshipsDisciplinesByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  const result = queryResult?.data?.length && transformEventChampionships(queryResult?.data);

  return {
    eventDisciplines: result || {},
    ...queryResult,
  };
};

export const useDisciplinesByIds = (ids, queryConfig = {}) => {
  const queryResult = useQuery(['disciplines', { ids }], api.disciplines.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    disciplines: queryResult.data || [],
    ...queryResult,
  };
};
